import { connect } from 'react-redux';
import { compose } from 'redux';

import __DEPRECATED_defineResources from 'dpl/shared/fetching/deprecated/defineResources';
import { exploreBreedsResourceDefinition } from 'dpl/shared/utils/tptConnectResourceDefinitions';
import { SUGGESTED_BREED_NAMES } from 'dpl/shared/constants/shared';
import BreederProfileSuggestedBreedsList from 'dpl/components/BreederProfile/Index/BreederProfileSuggestedBreedsList';

export default compose(
  __DEPRECATED_defineResources(() => ({
    breedsData: exploreBreedsResourceDefinition(true)
  })),
  connect(
    (
      { server },
      {
        breedsData: {
          value: { data }
        }
      }
    ) => {
      const currentBreedId = Number(server.breedId);

      return {
        suggestedBreeds: SUGGESTED_BREED_NAMES.reduce((breeds, name) => {
          const breed = data.find(b => b.name === name);
          if (breed && breed.id !== currentBreedId) {
            return [...breeds, breed];
          }

          return breeds;
        }, [])
      };
    }
  )
)(BreederProfileSuggestedBreedsList);
